/**
 * @namespace Teaserkarussell
 * @aka Planet.Teaserkarussell
 *
 */
Planet.Teaserkarussell = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'teaserkarusell';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy="teasercarousel"]'
  };

  var Default = {
    xsItems: 1
  };

  var DefaultType = {
    xsItems: '(number|boolean|undefined|window)',
    smItems: '(number|boolean|undefined|window)',
    mdItems: '(number|boolean|undefined|window)',
    lgItems: '(number|boolean|undefined|window)',
    xlItems: '(number|boolean|undefined|window)'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Teaserkarussell = function () {

    function Teaserkarussell(element, config) {
      var self = this;

      COMMON.Utils._classCallCheck(self, Teaserkarussell);

      self.element = element;

      var $element = $(self.element);

      Planet.Utils.destroySlick($element);

      self.config = self._getConfig(config);
      self.isRelated = $(self.element).closest('.relatedcontent').length !== 0;
      console.log(self.isRelated);

      var slickConfig = {
        centerPadding: '0px',
        mobileFirst: true,
        dots: true,
        infinite: true,
        speed: 214,
        swipeToSlide: true,
        regionLabel: "Karussell"
      };

      var $item = $element.children('[class*=col-]').first();
      if (1 === $item.length) {
        var classList = $item.attr('class').split(/\s+/);

        $.each(classList, function (index, item) {
          var classParts = item.split('-');
          self.config[classParts[1] + 'Items'] = Math.max(1, Math.min(12, Math.round(12 / parseInt(classParts[2]))));
        });
      }

      // Temporär entfernt
      /*if(1 === $element.data('sm-items')){
        slickConfig = $.extend({}, slickConfig, {
          autoplay: true,
          autoplaySpeed: 5000
        })
      }*/

      // if ($element.hasClass('teaser-crew')) {
      //   slickConfig = $.extend({}, slickConfig, {
      //     infinite: false
      //   })
      // }

      var responsive = [];
      var maxItems = $element.children().length;
      if (false === self.config.xsItems) {
        responsive.push({
          breakpoint: 0,
          settings: 'unslick'
        })
      } else if ('number' === typeof self.config.xsItems) {
        responsive.push({
          breakpoint: 0,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: self.config.xsItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.xsItems : 1
          }
        })
      }

      if (false === self.config.smItems) {
        responsive.push({
          breakpoint: 767,
          settings: 'unslick'
        })
      } else if ('number' === typeof self.config.smItems && !self.isRelated) {
        responsive.push({
          breakpoint: 767,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: self.config.smItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.smItems : 1
          }
        })
      } else if ('number' === typeof self.config.smItems && self.isRelated) {
        responsive.push({
          breakpoint: 767,
          settings: {
            slidesToShow: self.config.smItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.smItems : 1
          }
        })
      }

      if (false === self.config.mdItems) {
        responsive.push({
          breakpoint: 969,
          settings: 'unslick'
        })
      } else if ('number' === typeof self.config.mdItems) {
        responsive.push({
          breakpoint: 969,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: self.config.mdItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.mdItems : 1
          }
        })
      }

      if (false === self.config.lgItems) {
        responsive.push({
          breakpoint: 1199,
          settings: 'unslick'
        })
      } else if ('number' === typeof self.config.lgItems) {
        responsive.push({
          breakpoint: 1199,
          settings: {
            slidesToShow: self.config.lgItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.lgItems : 1
          }
        })
      }

      if (false === self.config.xlItems) {
        responsive.push({
          breakpoint: 1919,
          settings: 'unslick'
        })
      } else if ('number' === typeof self.config.xlItems) {
        responsive.push({
          breakpoint: 1919,
          settings: {
            slidesToShow: self.config.xlItems,
            slidesToScroll: $element.hasClass('teaser-crew') ? self.config.xlItems : 1
          }
        })
      }

      if (0 !== responsive.length) {
        slickConfig.responsive = responsive;
      }

      $element.on('beforeChange' + EVENT_KEY, function (event, slick, currentSlide, nextSlide) {
        $(document).trigger('common:pixel:pageview');
      });

      $element.slick(slickConfig);

      $(document).on('pjax:beforeReplace', function (event) {
        var $slick = $element;
        if (0 === $slick.length)
          return;
        try {
          $slick.slick('unslick')
        } catch (e) {
        }
      });

    }

    // private
    Teaserkarussell.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // public
    Teaserkarussell.prototype.dispose = function dispose() {
      $(this.element).off(EVENT_KEY);
      $(this.element).slick().unslick();
      this.element = null;
    };

    // static
    Teaserkarussell._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        if (!data) {
          data = new Teaserkarussell(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named ' + config + '');
          }
          data[config]();
        }
      });
    };

    return Teaserkarussell;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $teaserkarusell = $(this);
    Teaserkarussell._jQueryInterface.call($teaserkarusell);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $teaserkarusell = $(this);
      Teaserkarussell._jQueryInterface.call($teaserkarusell);
    })
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Teaserkarussell._jQueryInterface;
  $.fn[NAME].Constructor = Teaserkarussell;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Teaserkarussell._jQueryInterface;
  };

  return Teaserkarussell;

})(window.jQuery);
